module.exports = __webpack_public_path__ + "media/assets/images/blog/property_of-small-7d82147b61c57ac6f4ad03cf8da7dda7.png";